import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvProviderService} from './env-provider.service';
import {B2BToken} from '../interfaces/common.interfaces';
import {map, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class B2BTokensService {

  readonly ROOT_URL: string ;

  constructor(private http: HttpClient, private env: EnvProviderService) {
    this.ROOT_URL = this.env.environment.API_URL + '/common/b2b-tokens';
  }

  loadAllTokens$(): Observable<B2BToken[]> {
    return this.http.get<B2BToken[]>(`${this.ROOT_URL}`).pipe(
      map((rawTokens) => rawTokens.map((rawToken) => this.transformTokenFromServer(rawToken)))
    );
  }

  getB2BToken$(token: string): Observable<B2BToken> {
    return this.http.get<B2BToken>(`${this.ROOT_URL}/${token}`).pipe(
      map((rawToken) => this.transformTokenFromServer(rawToken))
    );
  }

  private transformTokenFromServer(raw: any): B2BToken {
    const token: B2BToken = {
      token: raw.token,
      config: raw.config,
      user: raw.user ? {
        id: raw.user.id,
        email: raw.user.email,
        username: raw.user.username,
        isSuperUser: raw.user.is_super_user,
      } : undefined,
      createdAt: new Date(raw.created_at),
      updatedAt: new Date(raw.updated_at),
    };
    return token;
  }
}
